import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { ToastService } from "src/app/services/toast.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialogRef } from "@angular/material/dialog";

interface CategoryData {
  categoryId?: string;
  Name: string;
  Description?: string;
  isActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
@Component({
  selector: "app-categoryform",
  templateUrl: "./categoryform.component.html",
  styleUrls: ["./categoryform.component.scss"],
})
export class CategoryformComponent implements OnInit {
  categoryList: any;
  dataSource: MatTableDataSource<unknown>;
  paginator: any;
  modified_By: any;
  created_By: any;
  categoryid: any;
  category: any;
  public validator = {
    errorMessage: "",
    UniqueCategory: false,
  };

  Category = new FormGroup({
    categoryId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  constructor(
    private daoService: DaoService,
    private fb: UntypedFormBuilder,
    private token: LstorageService,
    public dialogRef: MatDialogRef<CategoryformComponent>,
    private toast: ToastService
  ) {
    // this.daoService.getCategoryList().subscribe((data: any) => {
    //   this.categoryList = data;
    // });
  }
  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Category = this.fb.group({
      categoryId: [],
      name: ["", [Validators.required]],
      isActive: [true],
      description: [],
      createdBy: [this.daoService.loggedUser.UserUniqueId],
      createdOn: ["2020-01-18T18:20:07.433Z"],
      modifiedBy: [this.daoService.loggedUser.UserUniqueId],
      modifiedOn: ["2020-01-18T18:20:07.433Z"],
    });
  }

  createcategory() {
    console.log("entered createcategory");
    console.log("Form createcategory", this.Category.value);
    this.validator.UniqueCategory = false;
    this.Category.value.name = this.Category.value.name.trim();
    // const categoryData: CategoryData = {
    //   categoryId:
    //     this.Category.value.categoryId == ""
    //       ? null
    //       : this.category.value.categoryId,
    //   Description: this.Category.value.description,
    //   Name: this.category.value.name,
    //   createdOn: this.category.value.createdOn,
    //   createdBy: this.category.value.name,
    //   modifiedOn: this.category.value.modifiedOn,
    //   modifiedBy: this.category.value.modifiedBy,
    //   isActive: this.category.value.isActive,
    // };
    // Trim whitespace from name input
    const trimmedName = this.Category.value.name?.trim();

    const categoryData: CategoryData = {
      categoryId: this.Category.value.categoryId || null, // Use null if empty
      Description: this.Category.value.description || "", // Handle optional field
      Name: trimmedName,
      createdOn: this.Category.value.createdOn || new Date().toISOString(), // If not provided, set current date
      createdBy: this.Category.value.createdBy || "defaultUser", // Provide a fallback
      modifiedOn: this.Category.value.modifiedOn || new Date().toISOString(), // If not provided, set current date
      modifiedBy: this.Category.value.modifiedBy || "defaultUser", // Provide a fallback
      isActive: this.Category.value.isActive ?? true, // Default to true if undefined
    };
    console.log("categoryData", categoryData);
    this.daoService.AddCategory(categoryData).subscribe(
      (data: any) => {
        if (data.isSuccess) {
          this.toast.openSnackBar("Category added successfully", "close");
        }
        this.dialogRef.close();
      },
      (error) => {
        console.log(error);
        this.validator.UniqueCategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  closeUserForm() {
    this.dialogRef.close();
  }

  handleInput(event) {
    if (event.which === 32 && !this.Category.value.name.length)
      event.preventDefault();
  }
}
